/**
 * DreamMee — Male "They Don't Bite" Pose Assets
 * Merged into CHARACTER_CONFIG at runtime via config-new-poses.js
 */
const TDNB_MALE_ASSETS = {
  body_shadow: [
    { id: 'mtdnb_body_shadow', name: 'Default', src: 'demo-assets/characters/tdnb-male-pose/Body shadow.png' }
  ],
  body: [
    { id: 'mtdnb_body_1', name: 'Default', src: 'demo-assets/characters/tdnb-male-pose/body 1.png' }
  ],
  ears: [
    { id: 'mtdnb_ear_1', name: 'Default', src: 'demo-assets/characters/tdnb-male-pose/ear 1.png' }
  ],
  head: [
    { id: 'mtdnb_head_1', name: 'Default', src: 'demo-assets/characters/tdnb-male-pose/head base 1.png' }
  ],
  expression: [
    { id: 'mtdnb_exp_1', name: 'Expression 1', src: 'demo-assets/characters/tdnb-male-pose/expression 1.png' },
    { id: 'mtdnb_exp_2', name: 'Expression 2', src: 'demo-assets/characters/tdnb-male-pose/expression 2.png' }
  ],
  hair_front: [
    { id: 'mtdnb_hair_1', name: 'Style 1', src: 'demo-assets/characters/tdnb-male-pose/hair 1.png' },
    { id: 'mtdnb_hair_2', name: 'Style 2', src: 'demo-assets/characters/tdnb-male-pose/hair 2.png' },
    { id: 'mtdnb_hair_3', name: 'Style 3', src: 'demo-assets/characters/tdnb-male-pose/hair 3.png' },
    { id: 'mtdnb_hair_4', name: 'Style 4', src: 'demo-assets/characters/tdnb-male-pose/hair 4.png' },
    { id: 'mtdnb_hair_5', name: 'Style 5', src: 'demo-assets/characters/tdnb-male-pose/hair 5.png' }
  ],
  socks: [
    { id: 'mtdnb_socks_default', name: 'Default', src: 'demo-assets/characters/tdnb-male-pose/socks.png' },
    { id: 'mtdnb_socks_none', name: 'None', src: null }
  ],
  outfit_bottom: [
    { id: 'mtdnb_bottom_1_v1', name: 'Bottom 1', src: 'demo-assets/characters/tdnb-male-pose/outfit 1 bottom 1.png' },
    { id: 'mtdnb_bottom_2_v1', name: 'Bottom 2', src: 'demo-assets/characters/tdnb-male-pose/outfit 2 bottom 1.png' },
    { id: 'mtdnb_bottom_3_v1', name: 'Bottom 3', src: 'demo-assets/characters/tdnb-male-pose/outfit 3 bottom 1.png' },
    { id: 'mtdnb_bottom_4_v1', name: 'Bottom 4', src: 'demo-assets/characters/tdnb-male-pose/outfit 4 bottom 1.png' },
    { id: 'mtdnb_bottom_none', name: 'None', src: null }
  ],
  outfit_shirt: [
    { id: 'mtdnb_shirt_1_v1', name: 'Shirt 1', src: 'demo-assets/characters/tdnb-male-pose/outfit 1 shirt 1.png' },
    { id: 'mtdnb_shirt_2_v1', name: 'Shirt 2', src: 'demo-assets/characters/tdnb-male-pose/outfit 2 shirt 1.png' },
    { id: 'mtdnb_shirt_3_v1', name: 'Shirt 3', src: 'demo-assets/characters/tdnb-male-pose/outfit 3 shirt 1.png' },
    { id: 'mtdnb_shirt_4_v1', name: 'Shirt 4', src: 'demo-assets/characters/tdnb-male-pose/outfit 4 shirt 1.png' },
    { id: 'mtdnb_shirt_none', name: 'None', src: null }
  ],
  outfit_outer: [
    { id: 'mtdnb_outer_1_v1', name: 'Outer 1', src: 'demo-assets/characters/tdnb-male-pose/outfit 1 outer 1.png' },
    { id: 'mtdnb_outer_2_v1', name: 'Outer 2', src: 'demo-assets/characters/tdnb-male-pose/outfit 2 outer 1.png' },
    { id: 'mtdnb_outer_3_v1', name: 'Outer 3', src: 'demo-assets/characters/tdnb-male-pose/outfit 3 outer 1.png' },
    { id: 'mtdnb_outer_4', name: 'Outer 4', src: 'demo-assets/characters/tdnb-male-pose/outfit 4 outer.png' },
    { id: 'mtdnb_outer_none', name: 'None', src: null }
  ],
  outfit_chain: [
    { id: 'mtdnb_chain_1', name: 'Chain', src: 'demo-assets/characters/tdnb-male-pose/outfit 1 chain.png' },
    { id: 'mtdnb_chain_none', name: 'None', src: null }
  ]
};
